import { Col, Container, Row } from "react-bootstrap";
import BookingGuestForm from "../../../Components/Forms/BookingGuestForm/BookingGuestForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import useUploadImage from "../../../Hooks/UseUploadImage/useUploadImageHook";
import useMyProperties from "../../../Hooks/UseMyProperties/UseMyPropertiesHook";
import useMyPropertiesSelectValues from "../../../Hooks/UseMyProperties/UseMyPropertySelectValuesHook";
import { useAddNewBookingGuestMutation } from "../../../services/bClientApi";

export default function AddBookingGuestPage() {

  const { myProperties } = useMyProperties()
  const propertyOptions = useMyPropertiesSelectValues(myProperties)

  const [
    addNewBookingGuest,
    {
      error
    }
  ] = useAddNewBookingGuestMutation()

  const { uploadImageFn, uploadImageMultiFn, imageUploadProgress } = useUploadImage()

  const dispatch = useAppDispatch()
  const handleSubmit = async (data: any) => {
    const values: any = {
      ...data
    }
    const newBookingGuest = await addNewBookingGuest(values).unwrap()
    if (newBookingGuest._id) {
      dispatch(navigateTo(`/booking-guest/${newBookingGuest._id}`))
    }
    return newBookingGuest
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1>Add BookingGuest</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          <BookingGuestForm
            initialValues={{}}
            disabled={false}
            onSubmit={handleSubmit}
            uploadImageFn={uploadImageFn}
            uploadImageMultiFn={uploadImageMultiFn}
            imageUploadProgress={imageUploadProgress}
            propertyOptionList={propertyOptions}
          />

        </Col>
      </Row>
    </Container>
  )
}
